import React, { useState, useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '../hooks/storeHooks';
import { PDFDownloadLink } from '@react-pdf/renderer';
import {
    firstStepContainer,
    selectActiveTxt,
    finalContentTxt,
    nexBttn
} from '../styles/StepsStyles';
import Logo from '../assets/whiteLogoSvg.svg';
import { Button, Row } from 'antd';
import { logoImg } from '../styles/WelcomeStyles';
import { getAnalytics, logEvent } from '@firebase/analytics';
import DownloadParametricPDF from '../components/DownloadParametricPDF/DownloadParametricPDF';

var validator = require('validator');

const FinalStepView = () => {
    const { width } = useAppSelector(state => state.dimensions);
    const analytics = getAnalytics();
    const dataCotizacion = useAppSelector(state => state.DataCotizador);
    const LeasingResultCotizacion = useAppSelector(state => state.DataResponse.LeasingResultCotizacion);
    const CreditResultCotizacion = useAppSelector(state => state.DataResponse.CreditResultCotizacion);
    const ObjActivo = useAppSelector(state => state.DataResponse.ObjActivo);
    let Result = LeasingResultCotizacion;
    let CreditResult = CreditResultCotizacion;
    const assetName = ObjActivo.length === 0 ? '' : ObjActivo.filter(e => e.id === dataCotizacion.userActivo)[0].name

    useEffect(() => {
        logEvent(analytics, "view_final_screen");
    }, []);


    return (
        
            <Row style={{textAlign:'center', flexDirection:'column'}}>
                <p style={{ ...selectActiveTxt, width: '100%', marginInline: 'auto', marginBottom:1, padding:'0 30px'}}>
                    Tu proceso de preautorización concluyó con éxito
                </p>
                <div style={{ marginTop: 50, marginBottom: 'auto', padding:'0 30px' }}>
                    <p style={{ ...finalContentTxt, marginBottom: 20}}>
                        Se lograron completar con éxito todos los pasos necesarios para poder realizar tu proceso de preautorización.
                    </p>
                    <p style={{ ...finalContentTxt, marginBottom: 20, padding:'0 30px' }}>
                        En unos minutos recibirás la notificación con el resultado de ésta.
                    </p>
                </div>
                <div style={{display: 'flex', alignItems: "center", justifyContent: "center"}}>
                    <Button 
                        type="primary" 
                        style={{...nexBttn, marginBottom: width < 800 ? 10 : 0, padding:5, }}
                        shape='round'
                    >
                        <PDFDownloadLink 
                            document={
                                <DownloadParametricPDF 
                                    dataCotizacion={dataCotizacion} 
                                    Result={Result}
                                    assetName={assetName}
                                    CreditResult={CreditResult}
                                />
                            } 
                            fileName= {dataCotizacion.quoteType ==0? 'Simulación de arrendamiento' : 'Simulación de Credito'}>
                        {({ blob, url, loading, error }) =>
                            loading ? 'Cargando documento...' : 'Descargar mi simulación'
                        }
                        </PDFDownloadLink>
                    </Button>
                    
                </div>
                <div style={{ marginTop: 50, marginBottom: 'auto' }}>
                    <p style={{ ...finalContentTxt, marginBottom: 20, padding:'0 30px' }}>
                        Ponemos a tu disposición los siguientes números de contacto para dar seguimiento a tu proceso o resolver cualquier duda que tengas al respecto.
                    </p>
                    <p style={finalContentTxt}>
                        Correo: atencionaclientes@finbeabc.com.mx
                    </p>
                    <p style={finalContentTxt}>
                        WhatsApp: 55 2194 2464
                    </p>
                    <p style={finalContentTxt}>
                        Teléfono: 55 7005 5707
                    </p>
                    <p style={{ ...selectActiveTxt, marginInline: 'auto', marginTop: 30 }}>
                        ¡Muchas gracias por tu preferencia!
                    </p>
                <div style={{display: 'flex', alignItems: "center", justifyContent: "center"}}>
                    <img src={Logo} alt='Logo' style={{...logoImg, width: 300, marginTop: 30}} />
                </div>
                
                </div>
            </Row>
        
    )
}

export default FinalStepView;